import axios from "axios";
import i18n from "../i18n/i18n"
import {showErrorToast} from "../utils/toast"

const apiUrl = import.meta.env.VITE_API_URL;
const authLoginApiUri = import.meta.env.VITE_AUTH_LOGIN_API_URI;
const authLoginUrl = import.meta.env.VITE_AUTH_LOGIN_URL;

const authorizedApi = axios.create({
  baseURL: apiUrl,
  // withCredentials: true, // if using HttpOnly cookies
});

authorizedApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
// TODO - Check whether the token has expired
// If expired get a refresh token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

authorizedApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response?.status;
      const url = error.config?.url;

      if (status === 401 && !url?.includes(authLoginApiUri)) {
        showErrorToast(i18n.t("errors.auth.session_expired"));
        localStorage.removeItem("token");
        window.location.href = authLoginUrl;
      }
    } else {
      showErrorToast(i18n.t("errors.network.unable_to_connect"));
    }

    return Promise.reject(error);
  }
);

export default authorizedApi;
